import React from "react";

import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';

import PropTypes from "prop-types";

import './amountInput.scss';


class AmountInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isEditing: false };
  }

  onChange(event) {
    const maxInputRegex = /^[0-9]{0,7}$/;
    if (maxInputRegex.test(event.target.value)) {
      this.props.onChange(event.target.value);
    }
  }

  toCurrency(number) {
    const formatter = new Intl.NumberFormat("en-IN", {
    
    });

    return formatter.format(number);
  }

  toggleEditing() {
    this.setState({ isEditing: !this.state.isEditing });
  }

  render() {
    return (
      <div>
        {this.state.isEditing ? (
          <OutlinedInput
            type="number"
            className={`material-amountfield`}
            name={this.props.name}
            maxLength={7}
            value={this.props.inputValue}
            onChange={this.onChange.bind(this)}
            onBlur={this.toggleEditing.bind(this)}
            disabled={this.props.disableAmountText}
            style={{ width: "100%", backgroundColor: "#fff", borderRadius: 0, border: 'none' }}
            startAdornment={<InputAdornment position="start">₹</InputAdornment>}
          />
        ) : (
          <OutlinedInput
            type="text"
            name={this.props.name}
            maxLength={7}
            value={this.toCurrency(this.props.inputValue)}
            onFocus={this.toggleEditing.bind(this)}
            disabled={this.props.disableAmountText}
            style={{ width: "100%", backgroundColor: "#fff", borderRadius: 0, border: 'none' }}
            startAdornment={<InputAdornment position="start">₹</InputAdornment>}
            readOnly
          />
        )}
      </div>
    );
  }
}

AmountInput.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
};

export default AmountInput;
